import { useEffect, useState } from "react";
import api from "@/components/customAxios/Axios";
import ChangePasswordModal from "./ChangePasswordModal";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "../toast";
import useUserName from "@/context/UserNameContext";

const Account = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const { userName } = useUserName();
	const { setUserName } = useUserName();
	const [userData, setUserData] = useState({
		firstName: localStorage.getItem("firstName") || "",
		lastName: localStorage.getItem("lastName") || "",
		email: localStorage.getItem("email") || "",
		phoneNumber: localStorage.getItem("phoneNumber") || "",
	});
	const handleUserDataChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setUserData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const getUserDetails = async () => {
		try {
			setLoading(true);
			const response = await api.get("/current_user_details");
			if (response.status === 200) {

				setUserData({
					firstName: response.data.first_name,
					lastName: response.data.last_name,
					email: response.data.email,
					phoneNumber: response.data.phone_number,
				})
				setUserName(userData.firstName);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Fetching Account Details",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to fetch account details. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	const updateUserProfile = async () => {
		try {
			setLoading(true);
			const response = await api.post("/update_user_profile", {
				user_id: localStorage.getItem("user"),
				first_name: userData.firstName,
				last_name: userData.lastName,
				email: userData.email,
				phone_number: userData.phoneNumber,
			});
			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Profile updated successfully",
					description: "Your profile has been updated successfully.",
					open: true,
				});
				localStorage.setItem("firstName", userData.firstName);
				localStorage.setItem("lastName", userData.lastName);
				localStorage.setItem("email", userData.email);
				localStorage.setItem("phoneNumber", userData.phoneNumber);
				setUserName(userData.firstName);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Updating Account",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to update account settings. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => { getUserDetails() }, [])
	return (
		<div className="">
			<label className="block text-lg font-medium text-gray-400 mb-3">
				Account
			</label>
			<div>
				{/* <h3 className="text-gray-500">Profile Picture</h3> */}
				<div className="flex items-center gap-5 mt-3">
					<div className="size-24 text-3xl flex items-center justify-center rounded-full bg-gray-200 text-gray-600 font-normal">
						{userName[0].toUpperCase()}
					</div>
					{/* <div className=" flex  space-x-3 ">
						<button
							// onClick={addNewQuestion}
							className="bg-[#BDE4C3] text-[#438437] px-3 py-1 rounded"
						>
							Change Picture
						</button>
						<button
							// onClick={closeModal}
							className="px-4 py-2 text-[#438437] border-1 rounded-md hover:bg-gray-300 transition"
						>
							Delete Picture
						</button>
					</div> */}
				</div>
			</div>

			<div className="ml-3 mt-3  w-[90%]">
				<div className="grid md:grid-cols-2 gap-4">
					<div>
						<label className="block  font-medium text-gray-400 mb-2">
							First Name
						</label>
						<input
							value={userData.firstName}
							onChange={(e) => handleUserDataChange(e)}
							name="firstName"
							type="text"
							required
							placeholder="First Name"
							className="w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
						/>
					</div>
					<div>
						<label className="block  font-medium text-gray-400 mb-2">
							Last Name
						</label>
						<input
							value={userData.lastName}
							onChange={(e) => handleUserDataChange(e)}
							name="lastName"
							type="text"
							required
							placeholder="Last Name"
							className="w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
						/>
					</div>
				</div>
				<div className="grid md:grid-cols-2 gap-4">
					<div className="mt-3">
						<label className="block  font-medium text-gray-400 mb-2">
							Email
						</label>
						<input
							readOnly
							value={userData.email}
							onChange={(e) => handleUserDataChange(e)}
							name="email"
							type="email"
							autoComplete="email"
							required
							placeholder="Email"
							className="w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent cursor-not-allowed"
						/>
					</div>
					<div className="mt-3 flex items-center gap-3">
						<div className="flex-grow">
							<label className="block  font-medium text-gray-400 mb-2">
								Phone Number
							</label>
							<input
								value={userData.phoneNumber}
								onChange={(e) => handleUserDataChange(e)}
								pattern="[0-9]*"
								name="phoneNumber"
								type="number"
								required
								placeholder="0123456789"
								className="w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
							/>
						</div>
					</div>
				</div>

				<div className="mt-3 flex items-center justify-end gap-3">
					<button
						className="hover:scale-110 transition bg-[#BDE4C3] text-[#438437] px-3 py-2 rounded"
						onClick={updateUserProfile}
					>
						Update
					</button>
				</div>
				{localStorage.getItem("googleLogin") !== "true" && <div className="flex justify-start gap-5 items-center ">
					<div>
						<ChangePasswordModal />
					</div>
				</div>}
				{/* <div className="my-3">
					<p className=" font-medium text-gray-400 mb-2">Remove Account</p>
					<button className="bg-[#AF0200] text-white px-3 py-2 rounded mr-3">
						Disable Account
					</button>
					<button className="bg-[#E8E8E8] text-[#AF0200] px-3 py-2 rounded">
						Delete Account
					</button>
				</div> */}
			</div>
		</div>
	);
};

export default Account;
